import React from "react";
import { Link } from "react-router-dom";
import { downloadIcon } from "../SvgIcon";
function GridDownloads({card, files, fileName, preview ,Highlightcolor,Iconcolor ,iconcolor  ,Textcolor}) {
  
  // const Textcolor = card?.textColor ? card?.textColor : "#FFFFFF";
  // const Iconcolor = card?.iconBgColor ? card?.iconBgColor : "#FFFFFF";
  // const BgColor = card?.bgColor ? card?.bgColor : "";
  const BtIColor = card?.btIconColor ? card?.btIconColor : "#000000";

  return (
    <div className="grid grid-cols-2 items-center p-2 gap-3 ">
      {fileName?.fileName1 ? (
 <Link
 to={`${preview ? files.file1 : ""}`}
 target={`${preview ? "_blank" : ""}`}
>
<div className="max-w-[197px] h-[139px] border-[#F2F2F2] border  rounded-[8px] flex flex-col justify-between items-center " style={{background: `${Iconcolor ? Iconcolor : "black"}`}}>
  <div className="flex-grow flex items-center justify-center">
  <svg
  width="20"
  height="26"
  viewBox="0 0 20 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M3.75 24.25C3.08696 24.25 2.45107 23.9866 1.98223 23.5178C1.51339 23.0489 1.25 22.413 1.25 21.75V1.75H12.5L18.75 8V21.75C18.75 22.413 18.4866 23.0489 18.0178 23.5178C17.5489 23.9866 16.913 24.25 16.25 24.25H3.75Z"
    stroke={`${Highlightcolor ? Highlightcolor : "#888888"}`}
    stroke-width="1.875"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>

  </div>

  <p className="text-[12px] text-white font-medium  p-1 w-full rounded-b-[8px] text-center"   style={{ background: `${Highlightcolor ? Highlightcolor : ""}`,color: `${Textcolor ? Textcolor : "black"}`}}>
    {fileName.fileName1}
  </p>
</div>

</Link>

      ) : (
        ""
      )}
      {fileName?.fileName2 ? (
        <Link
          to={`${preview ? files.file2 : ""}`}
          target={`${preview ? "_blank" : ""}`}
        >
          <div className="max-w-[197px] h-[139px] border-[#F2F2F2] border bg-[#FAFAFA] rounded-[8px] items-center p-8">
            <div className="flex items-center justify-center h-[54px]">
            <svg
  width="20"
  height="26"
  viewBox="0 0 20 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M3.75 24.25C3.08696 24.25 2.45107 23.9866 1.98223 23.5178C1.51339 23.0489 1.25 22.413 1.25 21.75V1.75H12.5L18.75 8V21.75C18.75 22.413 18.4866 23.0489 18.0178 23.5178C17.5489 23.9866 16.913 24.25 16.25 24.25H3.75Z"
    stroke={`${Highlightcolor ? Highlightcolor : "#888888"}`}
    stroke-width="1.875"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>

            </div>

            <p className="text-[12px] text-black  font-medium text-center"   style={{ backgroundColor: `${Highlightcolor ? Highlightcolor : ""}` }}>
              {fileName.fileName2}
            </p>
          </div>
        </Link>
      ) : (
        ""
      )}
      {fileName?.fileName3 ? (
        <Link
          to={`${preview ? files.file3 : ""}`}
          target={`${preview ? "_blank" : ""}`}
        >
          <div className="max-w-[197px] h-[139px] border-[#F2F2F2] border bg-[#FAFAFAs] rounded-[8px] items-center p-8">
            <div className="flex items-center justify-center h-[54px]">
            <svg
  width="20"
  height="26"
  viewBox="0 0 20 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M3.75 24.25C3.08696 24.25 2.45107 23.9866 1.98223 23.5178C1.51339 23.0489 1.25 22.413 1.25 21.75V1.75H12.5L18.75 8V21.75C18.75 22.413 18.4866 23.0489 18.0178 23.5178C17.5489 23.9866 16.913 24.25 16.25 24.25H3.75Z"
    stroke={`${Highlightcolor ? Highlightcolor : "#888888"}`}
    stroke-width="1.875"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>

            </div>

            <p className="text-[12px] text-black font-medium text-center"   style={{ backgroundColor: `${Highlightcolor ? Highlightcolor : ""}` }}>
              {fileName.fileName3}
            </p>
          </div>
        </Link>
      ) : (
        ""
      )}
      {fileName?.fileName4 ? (
        <Link
          to={`${preview ? files.file4 : ""}`}
          target={`${preview ? "_blank" : ""}`}
        >
          <div className="max-w-[197px] h-[139px] border-[#F2F2F2] border bg-[#FAFAFA] rounded-[8px] items-center p-8">
            <div className="flex items-center justify-center h-[54px]">
            <svg
  width="20"
  height="26"
  viewBox="0 0 20 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M3.75 24.25C3.08696 24.25 2.45107 23.9866 1.98223 23.5178C1.51339 23.0489 1.25 22.413 1.25 21.75V1.75H12.5L18.75 8V21.75C18.75 22.413 18.4866 23.0489 18.0178 23.5178C17.5489 23.9866 16.913 24.25 16.25 24.25H3.75Z"
    stroke={`${Highlightcolor ? Highlightcolor : "#888888"}`}
    stroke-width="1.875"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>

            </div>

            <p className="text-[12px] text-black font-medium text-center"   style={{ backgroundColor: `${Highlightcolor ? Highlightcolor : ""}` }}>
              {fileName.fileName4}
            </p>
          </div>
        </Link>
      ) : (
        ""
      )}
    </div>
  );
}

export default GridDownloads;
